import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FeedbackScreen from "../components/child/FeedbackScreen";
import QrCodeEdit from "../components/child/QrCodeEdit";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery.js";
import "../components/CSS/ManageNewQR.css";
import {
  custom_qr_manage,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import Loader from "./Loader.js";

function ManageNewQR() {
  const [activeTab, setActiveTab] = useState("qrCode");
  const [showLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [bgColor, setBgColor] = useState("#fff");
  const [textColor, setTextColor] = useState("#333");
  const [qrCodeImage, setqrCodeImage] = useState("");
  const [bussinesText, setbussinesText] = useState("Adidas Pvt. Ltd.");
  const [tagLine, settagLine] = useState("Best Shop in Town");
  const [URLLINK, setURLLINK] = useState("Best Shop in Town");
  const [logoweb, setLogoweb] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [logourl, setLogourl] = useState("");
  const [logo, setLogo] = useState(null);

  // State for QR code styling
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState("frameBox1");

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(custom_qr_manage, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setURLLINK(final_data.url_link_go);

          setBgColor(final_data.User_Data.application_color);
          setTextColor(final_data.User_Data.application_text_color);
          setLogoweb(final_data.User_Data.website_logo);
          setbussinesText(final_data.User_Data.business_name);
          settagLine(final_data.User_Data.business_tagline);
          setSelectedFrame(final_data.User_Data.frame_name);
          setSelectedPattern(final_data.User_Data.parttan_name);
          setLogo(final_data.full_logo_url);
          setLogourl(final_data.user_linkss_link);
          setqrCodeImage(final_data.qr_image_base64);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);

  console.log("Bg Color", bgColor);
  return (
    <>
      {showLoaderAdmin && <Loader />}
      <MasterLayout>
        <div className="manage_qr_new_container">
          <div className=" d-flex flex-wrap align-items-center justify-content-between gap-3 mb-20">
            <div className="titleDash">
              {" "}
              <h6 className="fw-semibold mb-0">Manage QR & Feedback Screen</h6>
            </div>
            <div className="qrScreensBtns">
              <button
                className={`customizeBtns ${
                  activeTab == "qrCode" ? "activeCustomizeBtn" : ""
                } `}
                onClick={() => setActiveTab("qrCode")}
              >
                QR Code
              </button>
              <button
                className={`customizeBtns ${
                  activeTab == "Feedback" ? "activeCustomizeBtn" : ""
                } `}
                onClick={() => setActiveTab("Feedback")}
              >
                Feedback Screen
              </button>
            </div>
          </div>
          {activeTab === "qrCode" ? <QrCodeEdit /> : <FeedbackScreen />}
        </div>
      </MasterLayout>
    </>
  );
}

export default ManageNewQR;
